module.exports = __webpack_public_path__ + "img/plug-short-right.84564540.svg";